import routePaths from 'routes/routePaths';
import auth from 'utils/auth';
import questionIcon from 'assets/icons/side-menu/question.svg';
import supportIcon from 'assets/icons/side-menu/support.svg';
import complaintIcon from 'assets/icons/side-menu/complaint.svg';
import transferIcon from 'assets/icons/sidemenus-PNG/transfer.png';
import usersIcon from 'assets/icons/sidemenus-PNG/beneficiary_logo.png';
import homeIcon from 'assets/icons/sidemenus-PNG/dashboard_logo.png';
import walletIcon from 'assets/icons/sidemenus-PNG/wallet.png';
import creditCardIcon from 'assets/icons/sidemenus-PNG/credit-card.png';
import billsPayment from 'assets/icons/sidemenus-PNG/collections.png';
import fxTransferIcon from 'assets/icons/sidemenus-PNG/international transfer.png';
import transactionReport from 'assets/icons/sidemenus-PNG/Transaction Reports.png';
// import scheduledPayment from 'assets/icons/sidemenus-PNG/calendar.png';
import fileIcon from 'assets/icons/sidemenus-PNG/bank_statement.png';
import myRequest from 'assets/icons/sidemenus-PNG/my_request.png';
import pendingRequest from 'assets/icons/sidemenus-PNG/pending request.png';
import logOutIcon from 'assets/icons/sidemenus-PNG/logout.png';

export type SideMenuOptionsType = {
  icon: string;
  iconAlt: string;
  name: string;
  link?: string;
};

export const servicesOptions: SideMenuOptionsType[] = [
  { icon: questionIcon, iconAlt: 'question-icon', name: 'FAQs', link: routePaths.faq },
  { icon: supportIcon, iconAlt: 'support-icon', name: 'Contact Us', link: routePaths.contactUs },
  { icon: complaintIcon, iconAlt: 'complaint-icon', name: 'Complaint', link: routePaths.complaint },
];

export const test: SideMenuOptionsType[] = [
  { icon: supportIcon, iconAlt: 'help-icon', name: 'Help', link: routePaths.help },
];
export const dashboardOptions = () => {
  const menuArray: SideMenuOptionsType[] = [];

  if (auth.permissions.dashboard) {
    menuArray.push({ icon: homeIcon, iconAlt: 'home-icon', name: 'Dashboard', link: routePaths.dashboard });
  }
  if (auth.permissions.beneficiaries) {
    menuArray.push({ icon: usersIcon, iconAlt: 'users-icon', name: 'Beneficiaries', link: routePaths.beneficiaries });
  }
  if (auth.permissions.transfers) {
    menuArray.push({ icon: transferIcon, iconAlt: 'transfer-icon', name: 'Transfers', link: routePaths.transfer });
  }
  if (auth.permissions.mobileMoney) {
    menuArray.push({ icon: walletIcon, iconAlt: 'wallet-icon', name: 'Mobile Money', link: routePaths.mobileMoney });
  }
  if (auth.permissions.prepaidCardLoad) {
    menuArray.push({ icon: creditCardIcon,
      iconAlt: 'credit-card-icon',
      name: 'Prepaid Card Load',
      link: routePaths.prepaidCardLoad });
  }
  if (auth.permissions.billPayments) {
    menuArray.push({ icon: billsPayment,
      iconAlt: 'billsPayment-icon',
      name: 'Bill Payments',
      link: routePaths.billPayments });
  }
  if (auth.permissions.fxTransferRate) {
    menuArray.push({ icon: fxTransferIcon,
      iconAlt: 'international-transfer-icon',
      name: 'FX Transfer and Rates',
      link: routePaths.fxTransferRates,
    });
  }
  if (auth.permissions.transactionReports) {
    menuArray.push({
      icon: transactionReport,
      iconAlt: 'report-icon',
      name: 'Transaction Reports',
      link: routePaths.transactionReport,
    });
  }
  // if (auth.permissions.scheduleTransfers) {
  //   menuArray.push({
  //     icon: scheduledPayment,
  //     iconAlt: 'schedule-payment-icon',
  //     name: 'Schedule Transfers',
  //     link: routePaths.scheduleTransfers,
  //   });
  // }
  if (auth.permissions.bankStatements) {
    menuArray.push({
      icon: fileIcon, iconAlt: 'bank-statement-icon', name: 'Bank Statements', link: routePaths.bankStatement });
  }
  if (auth.permissions.pendingRequests) {
    menuArray.push({ icon: pendingRequest,
      iconAlt: 'pending-request-icon',
      name: 'Pending Requests',
      link: routePaths.pendingRequests });
  }
  if (auth.permissions.myRequests) {
    menuArray.push({ icon: myRequest, iconAlt: 'my-request-icon', name: 'My Requests', link: routePaths.myRequests });
  }
  return menuArray;
};

export const logoutOptions: SideMenuOptionsType = { icon: logOutIcon, iconAlt: 'log-out-icon', name: 'Log Out' };
